import type { Ref, PropType } from '@/composition/vue/compositionApi'
import type { ValidationRuleError, ValidationServerError } from '@/services/validation/types'

export type FieldComponent = new (...args: any) => {
  focus?: () => void
  blur?: () => void
}

export const fieldErrorProps = {
  field: {
    type: String,
    required: true,
  },
  errorCustomMessage: {
    type: String,
  },
  invalid: {
    type: Boolean,
    required: true,
  },
  errors: {
    type: Array as PropType<ValidationRuleError[]>,
    default: () => [],
  },
  serverErrors: {
    type: Array as PropType<ValidationServerError[]>,
    default: () => [],
  },
}

export const formLeftLabelSymbol = Symbol('formLeftLabel')
export type FormLeftLabel = Ref<boolean | undefined>

export const formLeftLabelWidthSymbol = Symbol('formLeftLabelWidth')
export type FormLeftLabelWidth = Ref<string | undefined>

export const formDisabledSymbol = Symbol('formDisabled')
export type FormDisabled = Ref<boolean | undefined>

export const formInputRef = Symbol('formInputRef')
export type FormInputRef = {
  focus?: () => void
  blur?: () => void
}

export const fieldErrorsIncludeRulesPassword = [
  'required',
  'min:8',
  'max:48',
  'hasNumbers',
  'hasSpecialChars',
  'hasLowercaseAndUppercase',
]

export const fieldSelectSearchWithCustomRulePrefix = 'fieldSelectSearchWithCustomRulePrefix'
export const fieldSenderPhoneRulePrefix = 'senderPhoneRulePrefix'

export type QFieldNativeStyle = Partial<
  Pick<CSSStyleDeclaration, 'gap' | 'minHeight' | 'paddingTop' | 'paddingRight' | 'paddingBottom' | 'paddingLeft'>
>
